// extracted by mini-css-extract-plugin
module.exports = {"button":"GlobalSearch_button__RLYH4","content":"GlobalSearch_content__2eyC7"};